import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IDataOperacion } from '../interfaces/operaciones.interface';
import { IDataProcedimiento } from '../interfaces/procedimientos.interface';
import { IDataTerapias } from '../interfaces/terapias.interface';
import { IDataMedicamento } from '../interfaces/tratamiento/medicamentos.interface';
import { IDataFrecuencias } from '../interfaces/tratamiento/terapias.interface';
import { IDataViasAdministracion } from '../interfaces/vias-admin.interface';
import { IndexdbService } from '../../core/database/indexdb.service';

@Injectable({
  providedIn: 'root',
})
export class TabTratamientoService {
  private readonly indexDbService: IndexdbService = inject(IndexdbService);

  getMedicamentos(): Observable<IDataMedicamento[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.medicamentos ?? [])
    );
  }

  getProcedimientos(): Observable<IDataProcedimiento[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.procedimientos ?? [])
    );
  }

  getTerapias(): Observable<IDataTerapias[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.terapias ?? [])
    );
  }

  getOperaciones(): Observable<IDataOperacion[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.operaciones ?? [])
    );
  }

  getViasAdministracion(): Observable<IDataViasAdministracion[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.viasAdministracion ?? [])
    );
  }

  getFrecuencias(): Observable<IDataFrecuencias[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.frecuencias ?? [])
    );
  }
}
